import React from 'react';
import EditIcon from "../EditIcon";
import AlertMessage from "../../AlertMessage";
import EditSection from "../EditSection";
import DiagnosisCodes from "../../DiagnosisCodes";

const DxCodesInformation = ({
	gearOrder,
	requisition,
	omsRequisition,
	userInfo,
	cancelEdit,
	saveEdit,
	editRef,
	editingReq,
	editingSection,
	isEditSaveInProgress,
	inlineSaveError,
	editSection,
	canEditDiagnosis,
	lastSavedReq,
	lastSavedSection
}) => {
	const isPatient = (userInfo && userInfo.type === 'prc');
	let dxCodes = [];
	// Convert selected icdCodes into JSX elements
	if( requisition?.icdCodes ) {
		dxCodes = requisition.icdCodes.map( (item, index) => <li className="col-sm-6 col-md-4" key={index}>{item.code} - {item.name}</li> );
	}

	const isInsurance = requisition?.billingMethod ?
		 (requisition.billingMethod.indexOf('Bill Insurance')>-1 || requisition.billingMethod.indexOf('Insurance - TESTING')>-1
			  || requisition.billingMethod.indexOf('Medicare')>-1): false;

	if (editingReq === `${requisition?.id}` && editingSection === 'dxCodes') {
		return (<div className="mt-20">
			<EditSection
				 title="Diagnostics Codes"
				 onCancel={cancelEdit}
				 onSave={saveEdit}
				 isEditSaveInProgress={isEditSaveInProgress}
			>
				<DiagnosisCodes
					 editRef={(ref) => (editRef.current = ref)}
					 userInfo={userInfo}
					 gearOrder={gearOrder}
					 omsRequisition={omsRequisition}
					 activeGearRequisitionId={requisition.id}
					 setDirty={() => {
					 }}
					 doConfirm={() => {
					 }}
					 showError={() => {
					 }}
					 setLoading={() => {
					 }}
					 setGearOrder={() => {
					 }}
					 setOmsRequisition={() => {
					 }}
					 setActiveGearRequisitionId={() => {
					 }}
					 updateStep={() => {
					 }}
				/>
				{inlineSaveError && <div
					 className="validation-error text-danger text-right">{inlineSaveError}</div>}
			</EditSection>
		</div>);
	}

	return (<>
		{dxCodes && dxCodes.length > 0 && <div className="row space-bottom" data-step={`dxCodes-${requisition?.id}`}>
			<div className="col-md-12">
				<strong>Diagnosis Codes
					{canEditDiagnosis && (<EditIcon
						 title="Diagnosis Codes"
						 onClick={editSection}
						 editKey={`dxCodes_${requisition?.id}`}
						 className="btn btn-edit btn-primary"
						 editEl="Edit"
					/>)}
					{lastSavedReq === `${requisition?.id}` && lastSavedSection === 'dxCodes' && (
						 <small>
                  <span className="ml-10 text-success">
                     Changes saved<i className="ml-5 fa fa-check-circle"></i>
                  </span>
						 </small>
					)}
				</strong>
				<ul className="list-unstyled">{dxCodes}</ul>
			</div>
		</div>}
		{((!dxCodes || dxCodes.length === 0) && (isInsurance || canEditDiagnosis) && !isPatient) && <div
			 className="row space-bottom" data-step={`dxCodes-${requisition?.id}`}>
			<div className="col-md-12">
				<strong>Diagnosis Codes
					{canEditDiagnosis && (<EditIcon
						 title="Diagnosis Codes"
						 onClick={editSection}
						 editKey={`dxCodes_${requisition?.id}`}
						 className="btn btn-edit btn-primary"
						 editEl="Edit"
					/>)}
					{lastSavedReq === `${requisition?.id}` && lastSavedSection === 'dxCodes' && (
						 <small>
                  <span className="ml-10 text-success">
                     Changes saved<i className="ml-5 fa fa-check-circle"></i>
                  </span>
						 </small>
					)}
				</strong>
				{isInsurance && (<AlertMessage type="danger">
					<strong>
						A diagnosis code is required. Click <EditIcon
						 title="Diagnosis Codes"
						 onClick={editSection}
						 editKey={`dxCodes_${requisition?.id}`}
						 className="btn-link btn-unstyled"
						 editEl="here"/> to add a
						diagnosis code to this requisition.
					</strong>
				</AlertMessage>)}
				{(!isInsurance) && (<div>None</div>)}
			</div>
		</div>}
	</>)
}

export default DxCodesInformation;
